import React from "react";

const ProductList = () => {
  return (
    <div className="product_list animate__animated animate__fadeIn">
      <div className="container product_list_main">
        <div className="product_list_img">
          <img src="/img/products/one.webp" alt="product img" />
        </div>
        <div className="product_list_content dm-sans">
          <h2>Adapt Active Noise Cancelling Headphones</h2>
          <h3>$50.00</h3>
          <p>
            Donec accumsan auctor iaculis. Sed suscipit arcu ligula, at egestas
            magna molestie a. Proin ac ex maximus, ultrices justo eget, sodales
            orci. Aliquam libero ac turpis pharetra, in vehicula scelerisque.
            Vestibulum ut sem laoreet, feugiat tellus at, hendrerit arcu.
          </p>
          <div className="product_list_opt">
            <i className="bi bi-heart"></i>
            <button>add to cart</button>
            <i className="bi bi-arrows-angle-contract"></i>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductList;
